import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ShipmentSpecialFreightNotificationsFacade } from './shipment-special-freight-notifications.facade';
import { SpecialFreightIdView } from '../../../../models';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ShipmentSpecialFreightItemFacade } from '../shipment-special-freight-item.facade';

@Injectable({ providedIn: 'root' })
export class ShipmentSpecialFreightNotificationsGuard {
  constructor(
    private shipmentSpecialFreightNotificationsFacade: ShipmentSpecialFreightNotificationsFacade,
    private shipmentSpecialFreightItemFacade: ShipmentSpecialFreightItemFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.shipmentSpecialFreightItemFacade.specialFreightIdentifier$.pipe(
      switchMap((identifier: SpecialFreightIdView) => {
        return loadStoreState(this.shipmentSpecialFreightNotificationsFacade, identifier);
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentSpecialFreightNotificationsFacade);
  }
}
